/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // reset each group
    document.querySelectorAll(".miniCartBodyGroup").forEach(element => element.innerHTML = "");

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // max quantity for chemical check
    if (localStorage.getItem("chemicals")) {
        // parse chemicals from localstorage
        const chemicals = JSON.parse(localStorage.chemicals);

        // loop through each chemical in the cart
        for (const item of cart.items) {
            // find the matching chemical based on sku
            const chemical = chemicals.find(chemical => chemical.heritageSKU === item.sku);

            // if chemical is found and delivery type is set
            if (chemical && item.properties?._deliveryType) {
                // determine available quantity based on delivery type
                const availableQuantity = chemical.availability[item.properties._deliveryType] || 0;

                // if current quantity is more than available quantity, update cart and exit
                if (item.quantity > availableQuantity) {
                    cart = await updateCart({updates: {[item.key]: availableQuantity}});
                    await openCart(true);
                    return;
                }
            }
        }
    }

    // max quantity for each product
    for (const item of cart.items) {
        if (productToMaxQuantity[item.product_id] && item.quantity > productToMaxQuantity[item.product_id]) {
            cart = await updateCart({updates: {[item.key]: 1}});
            await openCart(true);
            return;
        }
    }

    // GA4 view_cart
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "view_cart",
        ecommerce: {
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
            contains_upsell: cart.items.filter(item => item?.properties?.upsell).length > 0,
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_variant: item.variant_title,
                    item_category: item.type,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined,
                    item_upsell: item.properties?._upsell,
                    item_upsell_location: item.properties?._upsell_location,
                }
            }),
        }
    });

    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    // hide all parts of the cart
    document.querySelector("#headerCart").removeAttribute("count");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // empty cart, exit
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeaderTitle").textContent = "Your Cart is Empty";
        return;
    }
    document.querySelector("#miniCartHeaderTitle").textContent = "Your Cart";

    // update active sections
    document.querySelector("#headerCart").setAttribute("count", cart.item_count);
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // there are 3 product groups (general WG products, chemicals by branch, and chemicals by distribution center)
    const groups = {
        general: {
            items: [],
            subtotal: 0,
            header: `Standard shipping: <b>Free</b> with $75 orders`,
            footer: `Standard Shipping Subtotal: `
        },
        branch: {
            items: [],
            subtotal: 0,
            header: `Same day delivery: <b>Free</b> with $75 chemical orders`,
            footer: `Same Day Subtotal: `
        },
        distributionCenter: {
            items: [],
            subtotal: 0,
            header: `Standard shipping: <b>Free</b> with $75 chemical orders`,
            footer: `Standard Shipping Subtotal: `
        }
    };

    // keep track of savings for display
    let savings = 0;

    // append item to the DOM in the correct group
    cart.items.forEach(function (item) {
        // determine item group and push to group object
        let group;
        if (item.properties && item.properties._deliveryType === "branch") {
            group = "branch";
        } else if (item.properties && item.properties._deliveryType === "distributionCenter") {
            group = "distributionCenter";
        } else {
            group = "general";
        }
        groups[group].items.push(item);

        // update url for each item to include the group
        const productParams = new URLSearchParams();
        productParams.append("variant", item.variant_id);
        if (group !== "general") {
            productParams.append("deliveryType", group);
        }
        item.url = `/products/${item.handle}?${productParams.toString()}`;

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyGroupItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // qunaitity HTML
        function quantityHTML() {
            if (item.handle === "waterguru-test-free") {
                return `<div class="miniCartBodyGroupItemQuantityCount bundle">QTY: ${item.quantity}</div>`
            } else {
                // disable plus button if max quantity is reached for
                let disable = "";
                if (productToMaxQuantity[item.product_id] && item.quantity >= productToMaxQuantity[item.product_id]) {
                    disable = "disabled"
                }

                return `
                    <div class="miniCartBodyGroupItemQuantity">
                        <button class="miniCartBodyGroupItemQuantityMinus">-</button>
                        <div class="miniCartBodyGroupItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyGroupItemQuantityPlus" ${disable}>+</button>
                    </div>
                `;
            }
        }

        // price html
        function priceHTML() {
            let HTML = price(item.final_line_price) + " ";

            // check for subscription
            if (item.selling_plan_allocation) {
                // calculate comapre price
                const comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;

                // check if compare price is > than final price
                if (comparePrice > item.final_line_price) {
                    // add compare price
                    HTML += ` <s>${price(comparePrice)}</s>`;

                    // calculate savings
                    HTML += ` <br>${(1 - (item.final_line_price / comparePrice)).toFixed(2) * 100}% OFF`;

                    // add to current total cart savings
                    savings += (comparePrice - item.final_line_price);
                }
            }

            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                HTML += `<s>${price(item.original_line_price)}</s>`;

                // add to current total cart savings
                savings += (item.original_line_price - item.final_line_price);
            }
            // check for compare at price
            else if (variantToComparePrice[item.variant_id]) {
                HTML += `<s>${price(variantToComparePrice[item.variant_id] * item.quantity)}</s>`;

                // add to current total cart savings
                savings += (variantToComparePrice[item.variant_id] - item.final_line_price);
            }

            return HTML;
        }

        document.querySelector(`.miniCartBodyGroup[data-group="${group}"]`).insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyGroupItem" key="${item.key}">
                <img class="miniCartBodyGroupItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div class="miniCartBodyGroupItemInner">
                    <div class="miniCartBodyGroupItemInnerRow">
                        <div>
                            <a class="miniCartBodyGroupItemTitle" href="${item.url}">${item.product_title}</a>
                            ${subscriptionHTML()}
                        </div>
                        <div class="miniCartBodyGroupItemPrice">${priceHTML()}</div>
                    </div>
                    <div class="miniCartBodyGroupItemInnerRow">
                        ${quantityHTML()}
                        <button class="miniCartBodyGroupItemRemove" type="button" aria-label="remove item from cart">
                            <svg aria-hidden="true" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3517_5715)">
                                    <path d="M23.1484 5.925H1.85469C1.33594 5.925 0.914062 5.50312 0.914062 4.98437C0.914062 4.46562 1.33594 4.04375 1.85469 4.04375H23.1484C23.6672 4.04375 24.0891 4.46562 24.0891 4.98437C24.0891 5.50312 23.6672 5.925 23.1484 5.925Z" fill="#0B4266"/>
                                    <path d="M12.9834 24.7125H12.0146C8.55211 24.7125 6.64586 24.7125 5.28961 23.4469C3.93648 22.1813 3.80836 20.2781 3.57711 16.8219L3.00211 8.18125C2.96773 7.6625 3.35836 7.21563 3.87711 7.18125C4.39586 7.14688 4.84273 7.5375 4.87711 8.05625L5.45211 16.6969C5.65836 19.7719 5.76148 21.3156 6.57398 22.075C7.38648 22.8344 8.93336 22.8344 12.0146 22.8344H12.9834C16.0646 22.8344 17.6115 22.8344 18.424 22.075C19.2365 21.3156 19.3396 19.7719 19.5459 16.6969L20.1209 8.05625C20.1552 7.5375 20.6052 7.14688 21.1209 7.18125C21.6396 7.21563 22.0302 7.6625 21.9959 8.18125L21.4209 16.8219C21.1896 20.2781 21.0646 22.1813 19.7084 23.4469C18.3552 24.7125 16.4459 24.7125 12.9834 24.7125Z" fill="#0B4266"/>
                                    <path d="M9.99404 18.45C9.51592 18.45 9.10967 18.0875 9.05967 17.6031L8.43467 11.3406C8.38154 10.825 8.75967 10.3625 9.27529 10.3125C9.79092 10.2594 10.2534 10.6375 10.3034 11.1531L10.9284 17.4156C10.9815 17.9312 10.6034 18.3937 10.0878 18.4437C10.0565 18.4469 10.0253 18.45 9.99404 18.45Z" fill="#0B4266"/>
                                    <path d="M15.0058 18.45C14.9745 18.45 14.9433 18.45 14.912 18.4437C14.3964 18.3906 14.0183 17.9312 14.0714 17.4156L14.6964 11.1531C14.7495 10.6375 15.2089 10.2594 15.7245 10.3125C16.2401 10.3656 16.6183 10.825 16.5651 11.3406L15.9401 17.6031C15.8901 18.0875 15.4839 18.45 15.0058 18.45Z" fill="#0B4266"/>
                                    <path d="M19.3922 5.92499C19.3109 5.92499 19.2703 5.92499 19.2328 5.92499C18.5359 5.90624 17.8703 5.68437 17.3047 5.27499C16.7391 4.86874 16.3172 4.30624 16.0797 3.65312C16.0672 3.61874 16.0547 3.57812 16.0266 3.49999L15.9047 3.13437C15.8234 2.89374 15.7734 2.73749 15.7391 2.67187C15.6016 2.40937 15.3453 2.22499 15.0547 2.17812C14.9797 2.16562 14.8141 2.16562 14.5641 2.16562H10.4453C10.1922 2.16562 10.0266 2.16562 9.95469 2.17812C9.66094 2.22499 9.40781 2.40937 9.27031 2.67187C9.23594 2.73749 9.18281 2.89687 9.10469 3.13437L8.98281 3.49999C8.95781 3.57812 8.94219 3.61562 8.92969 3.65312C8.69219 4.30624 8.27031 4.86874 7.70469 5.27499C7.13906 5.68124 6.47344 5.90624 5.77656 5.92499C5.73906 5.92499 5.69844 5.92499 5.61719 5.92499V4.04687C5.67344 4.04687 5.70469 4.04687 5.72969 4.04687C6.37969 4.03124 6.94219 3.62499 7.16094 3.01562C7.17031 2.99062 7.17969 2.96249 7.19844 2.90937L7.32031 2.54374C7.43594 2.19687 7.49844 2.00624 7.60156 1.80624C8.01094 1.01874 8.77969 0.465619 9.65781 0.324994C9.87969 0.290619 10.0797 0.290619 10.4453 0.290619H14.5641C14.9297 0.290619 15.1297 0.290619 15.3516 0.324994C16.2297 0.465619 16.9953 1.01874 17.4078 1.80624C17.5109 2.00312 17.5734 2.19374 17.6891 2.54062L17.8109 2.90937C17.8297 2.96562 17.8391 2.99062 17.8484 3.01562C18.0703 3.62499 18.6328 4.03124 19.2797 4.04687C19.3047 4.04687 19.3359 4.04687 19.3922 4.04687V5.92499Z" fill="#0B4266"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_3517_5715">
                                        <rect width="25" height="25" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyGroupItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyGroupItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyGroupItemQuantityMinus")?.addEventListener("click", function () {
            if (quantity == 1) {
                element.querySelector(".miniCartBodyGroupItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyGroupItemQuantityPlus")?.addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyGroupItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out
            element.classList.add("fade");
        });

        // update quantity function
        async function updateCartItem() {
            // prevent future clicks
            element.classList.add("noClick");

            // update label
            element.querySelector(`.miniCartBodyGroupItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }
    });

    // calculate subtotal for each group
    let activeGroups = 0;
    for (const group in groups) {
        // skip if group is empty
        if (groups[group].items.length === 0) {
            continue;
        }

        // increment active groups
        activeGroups++;

        // calculate subtotal
        groups[group].subtotal = groups[group].items.reduce((acc, item) => acc + item.final_line_price, 0);
    }

    // if there are multiple groups
    if (activeGroups > 1) {
        // loop through each group
        for (const group in groups) {
            // skip if group is empty
            if (groups[group].items.length === 0) {
                continue;
            }

            // add header and footer
            document.querySelector(`.miniCartBodyGroup[data-group="${group}"]`).insertAdjacentHTML("beforeend", `
                <div class="miniCartBodyGroupHeader">${groups[group].header}</div>
                <div class="miniCartBodyGroupFooter">${groups[group].footer} ${price(groups[group].subtotal)}</div>
            `);
        }

        // update header
        document.querySelector("#miniCartHeaderShipments").textContent = `Your order ships as ${activeGroups} separate deliveries`;
    } else {
        // remove header
        document.querySelector("#miniCartHeaderShipments").textContent = "";
    }

    // check if this order has any cassette and has a sense s2
    const hasCassette = cart.items.filter(item => item.handle.includes("cassette")).length > 0;
    const hasSenseS2 = cart.items.filter(item => item.handle === "waterguru-sense").length > 0;

    // show upsell if this order does not have any cassette
    if (upsellProduct && !hasCassette && hasSenseS2) {
        document.querySelector("#miniCartUpsell").classList.add("active");

        // track
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                contains_upsell: true,
                currency: Shopify.currency.active,
                price: upsellProduct.price / 100,
                items: [
                    {
                        item_id: upsellProduct.variants[0].id,
                        item_name: upsellProduct.title,
                        item_variant: upsellProduct.variants[0].title,
                        item_category: upsellProduct.variants[0].type,
                        price: upsellProduct.price / 100,
                        quantity: 1,
                        item_upsell: true,
                        item_upsell_location: "mini_cart",
                    }
                ]
            }
        });
    }

    // update textarea
    let hasChemicals = cart.items.filter(item => {
        return item.sku != null && !item.sku.includes("WG-");
    });
    if (hasChemicals.length > 0) {
        document.querySelector("#miniCartFooterNote").classList.add("active");
        document.querySelector("#miniCartFooterNoteTextarea").value = cart.note;
    } else {
        document.querySelector("#miniCartFooterNote").classList.remove("active");
        document.querySelector("#miniCartFooterNoteTextarea").value = "";
    }

    // update subtotal
    document.querySelector("#miniCartFooterSubtotal span:last-child").textContent = price(cart.items_subtotal_price);
    console.log("\n\nsavings\n---", savings, "\n\n")
    // update savings
    document.querySelector("#miniCartFooterSavings").textContent = savings > 0 ? `You Saved ${price(savings)}` : "";
}

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart().catch(err => console.log(err));
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // GA4 begin_checkout
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
            contains_upsell: cart.items.filter(item => item?.properties?.upsell).length > 0,
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_variant: item.variant_title,
                    item_category: item.type,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined,
                    item_upsell: item.properties?._upsell,
                    item_upsell_location: item.properties?._upsell_location,
                }
            }),
        }
    });

    // update order note if it does not match shopify
    if (document.querySelector("#miniCartFooterNoteTextarea").value !== cart.note) {
        await updateCart({"note": document.querySelector("#miniCartFooterNoteTextarea").value});
    }

    // stop loading
    this.classList.remove("loading");

    window.location.href = "/checkout";
});

// upsell event listener
document.querySelector("#miniCartUpsellButton").addEventListener("click", async function () {
    // determine which upsell_purchase is selected
    const purchaseType = document.querySelector(`.miniCartUpsellGridFormSubscriptionLabelInput:checked`)?.value;

    // alert if no upsell_purchase is selected
    if (!purchaseType) {
        alert("Please select one time or subscription.");
        return;
    }

    // start loading
    this.classList.add("loading");

    // aggregate form data
    let formdata = {
        id: upsellProduct.variants[0].id,
        selling_plan: purchaseType === "subscription" ? upsellProduct.selling_plan_groups[0].selling_plans[0].id : null,
        quantity: 1,
        properties: {
            "_upsell": true,
            "_upsell_location": "mini_cart"
        }
    };

    // trigger dataLayer track
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: purchaseType === "subscription",
            contains_upsell: true,
            value: upsellProduct.price / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: upsellProduct.id,
                item_name: upsellProduct.title,
                item_variant: upsellProduct.variants[0].title,
                item_category: upsellProduct.type,
                price: upsellProduct.price / 100,
                quantity: 1,
                subscription_item: purchaseType === "subscription",
                item_upsell: true,
                item_upsell_location: "mini_cart"
            }],
        }
    });

    // add to cart
    await addProduct(formdata);

    // refresh cart
    await openCart();

    // stop loading
    this.classList.remove("loading");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart().catch(err => console.log(err));
}